import { c as _c } from "react/compiler-runtime";
import { cn } from '@core/utils';
import { UnauthApi, UnauthQueryKey } from '@/api';
import { InfiniteListWithMoreButton } from '@/app/donation/_components/InfiniteListWithMoreButton';
import { DONATION_ROUTES } from '@/constants';
import { InfiniteListMoreButton } from '../InfiniteListMoreButton';
import { SectionTitle } from '../SectionTitle';
import { ContentsListItem } from './ContentsListItem';
interface ContentsContentProps {
  institutionId: number;
}
const PAGE_SIZE = 3;
export const ContentsContent = t0 => {
  const $ = _c(12);
  const {
    institutionId
  } = t0;
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <SectionTitle className={cn("mb-32", "mobile-tablet:mb-12")}>콘텐츠</SectionTitle>;
    t2 = cn("grid grid-cols-3 gap-x-18 gap-y-40", "mobile-tablet:grid-cols-1");
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <InfiniteListMoreButton className={cn("mt-30", "mobile-tablet:-mt-4")} />;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  let t5;
  if ($[3] !== institutionId) {
    t4 = [...UnauthQueryKey["get:/wello/v2/allows/home/institution-content"](), institutionId, PAGE_SIZE];
    t5 = t6 => {
      const {
        pageParam
      } = t6;
      return UnauthApi["get:/wello/v2/allows/home/institution-content"]({
        query: {
          institutionId,
          page: pageParam,
          size: PAGE_SIZE
        }
      }).then(_temp);
    };
    $[3] = institutionId;
    $[4] = t4;
    $[5] = t5;
  } else {
    t4 = $[4];
    t5 = $[5];
  }
  let t6;
  if ($[6] !== institutionId) {
    t6 = (item, index) => <ContentsListItem imageUrl={item.thumbnailUrl} title={item.title} summary={item.summary} href={DONATION_ROUTES.HOMETOWNS_CONTENTS_DETAIL.pathname({
      hometownsId: institutionId,
      contentsId: item.contentId
    })} priority={index < 2} />;
    $[6] = institutionId;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== t4 || $[9] !== t5 || $[10] !== t6) {
    t7 = <div>{t1}<div className={t2}><InfiniteListWithMoreButton moreButtonComponent={t3} queryKey={t4} queryFn={t5} pageSize={PAGE_SIZE} renderItem={t6} getItemKey={_temp2} /></div></div>;
    $[8] = t4;
    $[9] = t5;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  return t7;
};
function _temp(data) {
  return data.data?.context?.contents ?? [];
}
function _temp2(item_0) {
  return item_0.contentId;
}